const es_vaillant = {
  WELCOME_TO_NEMURU: "Bienvenid@",
  // TERMS_AND_CONDITIONS: (
  //   <div style={{ paddingRight: "8px" }}>
  //     <div style={{ marginTop: 0 }}>
  //       <h3 style={{ marginTop: 0 }}>
  //         <p>
  //           <strong>
  //             Para iniciar esta solicitud, es obligatorio que leas y nos des tu
  //             consentimiento para que podamos consultar tus datos tal y como se
  //             indica en este texto:
  //           </strong>
  //         </p>
  //       </h3>
  //     </div>
  //     <p>
  //       A los efectos previstos en la normativa de protección de datos de
  //       carácter personal, las siguientes Entidades Financieras (cada una de
  //       ellas individualmente como el "Responsable" o colectivamente como los
  //       "Responsables"):
  //     </p>
  //     <ul className="terms-and-conditions-ul">
  //       <li>
  //         <strong>Banco Bilbao Vizcaya Argentaria, S.A. (BBVA)</strong>, con
  //         domicilio social en Plaza San Nicolás 4, 48005, Bilbao; Dirección de
  //         correo electrónico:<span>&nbsp;</span>
  //         <a href="mailto:consultasgenerales@bbva.com">
  //           consultasgenerales@bbva.com
  //         </a>
  //         ; Canales de ejercicio de derechos: enviando un correo electrónico a
  //         <span>&nbsp;</span>
  //         <a href="mailto:derechosprotecciondatos@bbva.com">
  //           derechosprotecciondatos@bbva.com
  //         </a>
  //         ; presentando un escrito en cualquiera de las oficinas. Delegado de
  //         Protección de Datos:<span>&nbsp;</span>
  //         <a href="mailto:dpogrupobbva@bbva.com">dpogrupobbva@bbva.com</a>.
  //         Puedes consultar la información adicional y detallada en
  //         <span>&nbsp;</span>
  //         <a href="https://www.bbvaconsumerfinance.es" target="_blank">
  //           www.bbvaconsumerfinance.es
  //         </a>
  //         , en el enlace "Ampliar información acerca del tratamiento de datos
  //         relacionado con solicitudes de financiación".
  //       </li>
  //     </ul>
  //     <p>
  //       le informan que, con motivo de su solicitud de financiación de productos
  //       de climatización, necesitan tratar los siguientes datos personales:
  //     </p>
  //     <ul className="terms-and-conditions-ul">
  //       <li>
  //         Datos identificativos y de contacto: nombre, apellidos, sexo, edad,
  //         estado civil, nacionalidad, teléfono fijo, teléfono móvil, correo
  //         electrónico, DNI, pasaporte o NIE y su fecha de caducidad, dirección
  //         postal, lugar de nacimiento.
  //       </li>
  //       <li>
  //         Datos económicos y de solvencia patrimonial: situación laboral, tipo
  //         de contrato, profesión, sector de actividad, antigüedad en el empleo,
  //         nombre de la empresa y datos de contacto, ingresos netos mensuales,
  //         ingresos y gastos, situación de la vivienda.
  //       </li>
  //     </ul>
  //     <p>
  //       los cuales serán tratados por el pertinente Responsable o Responsables
  //       (en caso de que su solicitud sea denegada por un Responsable, podrá ser
  //       gestionada por otro, sin que esto garantice la aprobación de su
  //       solicitud) con la finalidad de gestionar su solicitud de financiación.
  //     </p>
  //     <p>
  //       La base de legitimación que permite al Responsable tratar sus datos
  //       personales para la citada finalidad es la ejecución de su solicitud de
  //       financiación.
  //     </p>
  //   </div>
  // ),
};

export default es_vaillant;
